export const isEmpty = value => 
  value === undefined ||              // undefined variable
  value === 'undefined' ||
  value === '' ||                     // empty string
  value === null ||                   // null value check
  Object.keys(value).length === 0 || // empty JSON check
  value.length === 0;                // array length check

export const showGreenTick = (dispatch) => {
  // show green tick for 2 seconds.
  dispatch({ type: 'SHOW_GREEN_TICK' })

  // disabled green tick after 1.5 seconds.
  setTimeout(()=> {
    dispatch({ type: 'DISABLE_GREEN_TICK' })
  }, 1500);
}

export const getDate = (datestring) => {

  const monthName = [ "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December" ]
  const d = new Date(datestring);
  const date = d.getDate();
  const month = d.getMonth();
  const year = d.getFullYear();

  return `${date} ${monthName[month]} ${year}`
}